const GUIDE_BY_ID = {
  sentadillas: 'Baja con el abdomen firme y las rodillas siguiendo la línea de los pies. Empuja el suelo para subir.',
  'sentadillas-barra': 'Apoya la barra estable sobre la espalda, baja con control y empuja el suelo para volver arriba.',
  'press-banca': 'Escápulas atrás, pies firmes y barra hacia la parte media del pecho. Empuja sin despegar los hombros.',
  'press-inclinado-mancuernas': 'Mantén los hombros atrás, baja las mancuernas con control y empuja hacia arriba sin chocarlas.',
  'press-militar': 'Aprieta glúteos y abdomen. Lleva la carga sobre la cabeza sin arquear la zona lumbar.',
  dominadas: 'Inicia con hombros abajo, lleva el pecho hacia la barra y baja de forma controlada.',
  'dominadas-supinas': 'Mantén el pecho alto, tira con los codos hacia abajo y evita balancearte.',
  remo: 'Inclina el torso estable, lleva los codos hacia la cadera y no redondees la espalda.',
  'peso-muerto': 'Mantén la barra cerca del cuerpo, espalda neutra y empuja el suelo con las piernas.',
  zancadas: 'Da un paso estable, baja recto y empuja con el pie delantero para volver a la posición inicial.',
  flexiones: 'Crea una línea recta de hombros a talones, baja el pecho entre las manos y empuja el suelo.',
  'curl-biceps-mancuernas': 'Mantén los codos quietos junto al cuerpo y sube sin balancear el torso.',
  'elevaciones-laterales-mancuernas': 'Eleva los brazos con los codos ligeramente flexionados, sin encoger los hombros.',
  'extension-triceps-polea': 'Fija los codos al costado y extiende los brazos sin mover los hombros.',
  'face-pull-polea': 'Tira hacia la cara con los codos altos y junta los omóplatos al final del recorrido.',
  'hip-thrust': 'Apoya la espalda alta en el banco, empuja con los talones y aprieta los glúteos arriba.',
  'elevacion-gluteos-barra': 'Empuja con los talones y termina con cadera neutra; no hiperextiendas la espalda.',
  abdominales: 'Pega la zona lumbar al suelo, eleva el torso con el abdomen y evita tirar del cuello.',
  plancha: 'Aprieta abdomen y glúteos, manteniendo una línea recta sin hundir la zona lumbar.',
};

const GUIDE_BY_PATTERN = {
  'Empuje Horizontal': 'Estabiliza los hombros, controla la bajada y empuja sin perder la postura.',
  'Empuje Vertical': 'Mantén el abdomen firme y lleva la carga en una trayectoria controlada.',
  'Tracción Horizontal': 'Mantén el torso estable y lleva los codos hacia atrás sin encoger los hombros.',
  'Tracción Vertical': 'Baja los hombros, tira con los codos y evita usar impulso.',
  'Dominante de Rodilla': 'Rodillas alineadas con los pies, tronco firme y recorrido controlado.',
  'Dominante de Cadera': 'Mueve la cadera atrás manteniendo la espalda neutra y aprieta glúteos al final.',
  'Aislamiento Bíceps': 'Mantén el codo fijo y evita balancear el cuerpo para mover la carga.',
  'Aislamiento Tríceps': 'Mantén los codos estables y extiende sin compensar con los hombros.',
  'Flexión de Tronco': 'Activa el abdomen, controla la subida y no tires del cuello.',
};

export function getExerciseGuide(exercise = {}) {
  const summary = exercise.short_instruction
    || exercise.short_description
    || GUIDE_BY_ID[exercise.id]
    || GUIDE_BY_PATTERN[exercise.movement_pattern]
    || `Realiza el movimiento de ${exercise.name || 'este ejercicio'} con control, postura estable y sin dolor.`;

  return {
    summary,
    execution: exercise.execution_steps || [summary],
    breathing: exercise.breathing || 'Inhala en la fase de vuelta y exhala al realizar el esfuerzo.',
    mistakes: exercise.common_mistakes || ['Perder una postura estable', 'Usar impulso en lugar de controlar el movimiento'],
    muscles: {
      primary: exercise.target || exercise.target_muscle || 'Principal',
      secondary: Array.isArray(exercise.secondary_muscles)
        ? exercise.secondary_muscles
        : String(exercise.secondary_muscles || 'Estabilizadores').split(',').filter(Boolean),
    },
    proTip: exercise.pro_tip || 'Prioriza un rango de movimiento que puedas controlar sin molestias.',
  };
}
